import { memo } from 'react'

const ResentPage: React.FC = memo(() => <div>ResentPage</div>)

export { ResentPage }
